import Header from "./components/Header";
import Hero from "./components/Hero";
import Breadcrumb from "./components/Breadcrumb";
import ProcessSection from "./components/ProcessSection";
import KeyQuestions from "./components/KeyQuestions";
import TimelineSection from "./components/TimelineSection";
import PrivacySection from "./components/PrivacySection";
import FeeSection from "./components/FeeSection";
import FormatSection from "./components/FormatSection";
import RejectSection from "./components/RejectSection";
import FaqSection from "./components/FaqSection";
import Testimonials from "./components/Testimonials";
import SubmitForm from "./components/SubmitForm";
import Footer from "./components/Footer";
import BackToTop from "./components/BackToTop";
import StructuredData from "./components/StructuredData";

export default function Home() {
  return (
    <div className="w-full min-h-screen bg-background-50 font-body">
      <StructuredData />
      <Header />
      <main className="w-full">
        <Hero />
        <Breadcrumb />
        <ProcessSection />
        <KeyQuestions />
        <TimelineSection />
        <PrivacySection />
        <FeeSection />
        <FormatSection />
        <RejectSection />
        <FaqSection />
        <Testimonials />
        <SubmitForm />
      </main>
      <BackToTop />
      <Footer />
    </div>
  );
}